export const LANGUAGES = [
  { value: "cpp", label: "C++" },
  { value: "python", label: "Python" },
  { value: "javascript", label: "JavaScript" },
];

export const LANGUAGE_MAP = {
  cpp: "cpp",
  python: "python",
  javascript: "javascript",
};
